import autobind from "class-autobind"
import { CircularProgress, FloatingActionButton, Toggle, MenuItem, SelectField } from "material-ui"
import ContentAdd from "material-ui/svg-icons/content/add"
import React from "react"
import * as api from "../../../api"
import TableActionBar from "../../../components/layout/TableActionBar"
import strings from "../../../localization/strings"
import ClearIcon from "material-ui/svg-icons/content/clear"
import { IDate, IUserDocument, EListCalendarViewModes, IJobStatus, IJobSubStatus, IUserJobSearch } from "../../../models"
import DateRangeSelect from "../../../components/common/DateRangeSelect"
import AccountStore from "../../../stores/AccountStore"
import AddUserDetailRequestedJobDialog from "./AddUserDetailRequestedJobDialog"
import UserDetailsJobsTable from "./UserDetailsJobsTable"
import ChooseListCalendarViewMode from "../../../components/common/ChooseListCalendarViewMode"
import DateFilterForCalendarView from "../../../components/common/DateFilterForCalendarView"
import { browserHistory } from "react-router"
import UserJobCalendarView from "../../../components/job/user_job_calendar_view/UserJobCalendarView"
import moment from "moment"
import * as utils from "../../../helpers/utils"
import { checkJobFieldAvailable } from "../../../helpers/jobHelper"
import Account from "../../account/Account"

interface IProps {
    user: IUserDocument
}
interface IState {
    useDateFilter: boolean
    viewMode: EListCalendarViewModes
    startDate: IDate
    endDate: IDate
    referenceDateForCalendarView: IDate
    loading: boolean
    userJobs: IUserJobSearch[]
    searchText: string
    selectedJobs: IUserJobSearch[]
    total: number
    offset: number
    limit: number
    openJobRequestDialog: boolean
    showDateFilter: boolean
    jobStatuses: IJobStatus[]
    status: IJobStatus
    subStatus: IJobSubStatus
    requested: boolean
    available: boolean
    confirmed: boolean
    miles: number
}

export interface IJobQueryFilter {
    StartDate: string
    EndDate: string
}

export default class UserDetailsJobs extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        const useDateFilter = utils.getCookie("UseDateFilterForUserJobPage") === "true"
        this.state = {
            useDateFilter,
            viewMode: EListCalendarViewModes.ListView,
            startDate: moment().startOf("month").format(),
            endDate: moment().endOf("month").format(),
            referenceDateForCalendarView: moment().format(),
            loading: false,
            userJobs: [],
            searchText: "",
            selectedJobs: [],
            total: 0,
            offset: 0,
            limit: 50,
            openJobRequestDialog: false,
            showDateFilter: true,
            jobStatuses: [],
            status: null,
            subStatus: null,
            requested: AccountStore.getCRMEnabled(),
            available: false,
            confirmed: !AccountStore.getCRMEnabled(),
            miles: undefined,
        }
        autobind(this)
    }

    componentDidMount() {
        this.getUserJobs()
        this.getJobStatuses()
    }

    getJobStatuses() {
        AccountStore.getHREnabled() &&
            api.getJobStatuses(AccountStore.getCurrentAccount().Id).then(res =>
                this.setState({ jobStatuses: res.data })
            )
    }

    getUserJobs = async () => {
        this.setState({ loading: true }, () => {
            (this.state.requested || this.state.available || this.state.confirmed) ?
                api.searchUserJobsResult(this.props.user.Id, {
                    AccountId: this.props.user.AccountId,
                    Search: this.state.searchText,
                    Page: this.state.offset / this.state.limit,
                    Limit: this.state.limit,
                    StartDate: this.state.useDateFilter ?
                        this.state.viewMode === EListCalendarViewModes.ListView ?
                            this.state.startDate as string :
                            moment(this.state.referenceDateForCalendarView).utc(true).startOf("month").format() :
                        "",
                    EndDate: this.state.useDateFilter ?
                        this.state.viewMode === EListCalendarViewModes.ListView ?
                            this.state.endDate as string :
                            moment(this.state.referenceDateForCalendarView).utc(true).endOf("month").format() :
                        "",
                    JobStatusId: this.state.status && this.state.status.Id,
                    JobSubStatusId: this.state.subStatus && this.state.subStatus.Id,
                    Requested: this.state.requested,
                    Available: this.state.available,
                    Confirmed: this.state.confirmed,
                    Miles: this.state.miles,
                })
                    .then((res) => {
                        this.setState({
                            loading: false,
                            userJobs: res.data.CandidateJobSearchResults as IUserJobSearch[],
                            total: res.data.TotalDocumentCount,
                        })
                    }) :
                this.setState({
                    loading: false,
                    userJobs: [],
                    total: 0
                })
        })
    }

    handleRequestJob = async (jobId: string) => {
        return api.requestJobForEmployee(jobId, this.props.user.Id).then(console.log).catch(console.error)
    }

    render() {
        const dateFilter = (
            <div style={{ display: "flex", marginLeft: "auto", marginTop: -17, order: 2 }}>
                {this.state.viewMode === EListCalendarViewModes.ListView ?
                    // Date Filter 
                    <div style={{ display: "flex" }}>
                        {this.state.showDateFilter && (
                            <DateRangeSelect
                                startDate={this.state.startDate}
                                endDate={this.state.endDate}
                                handleChange={(startDate, endDate, isValid) => isValid && this.setState({ startDate, endDate }, () => this.getUserJobs())}
                            />
                        )}
                        {(this.state.startDate !== null || this.state.endDate !== null) &&
                            <ClearIcon
                                data-intercom-target={"menu-Employees-Jobs-Btn-ClearDateFilter"}
                                style={{ marginLeft: "1%", marginTop: "9%", cursor: "pointer" }}
                                onClick={() =>
                                    this.setState({ startDate: null, endDate: null }, () => {
                                        this.getUserJobs()
                                        this.setState({ showDateFilter: false }, () => this.setState({ showDateFilter: true }))
                                    })
                                }
                            />
                        }
                    </div> :
                    // Calendar Filter
                    <DateFilterForCalendarView
                        referenceDate={this.state.referenceDateForCalendarView}
                        handleUpdateDateFilter={dateFilter => this.setState({ referenceDateForCalendarView: dateFilter.StartDate }, () => this.getUserJobs())}
                    />
                }
            </div>
        )
        const CRMEnabled = AccountStore.getCRMEnabled()
        return (
            <div className="detail-tab">
                <div className="UserDetailsRequestedJobs" style={{ position: "relative" }}>
                    {CRMEnabled &&
                        <FloatingActionButton data-intercom-target={"menu-Employees-Jobs-Btn-AddNewJob"} style={{ position: "relative", float: "right", right: 50, top: -45 }} secondary onTouchTap={() => this.setState({ openJobRequestDialog: true })}>
                            <ContentAdd />
                        </FloatingActionButton>
                    }
                    <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: -10 }}>
                        <Toggle
                            data-intercom-target={"menu-Employees-Jobs-Toggle-UseDateFilter"}
                            toggled={this.state.useDateFilter}
                            onToggle={(e, value) => this.setState({ useDateFilter: value, offset: 0, searchText: "" }, () => {
                                this.getUserJobs()
                                localStorage.setItem("findd_UseDateFilterForUserJobPage", value)
                            })}
                            labelPosition="left"
                            label={strings.Use_Date_Filter}
                            style={{ width: 150, marginTop: 13 }}
                        />
                    </div>
                    <TableActionBar
                        rowSelectionCount={this.state.selectedJobs.length}
                        singleSelectedMessage={strings.Job_Selected}
                        multipleSelectedMessage={strings.x_Job_Selected}
                        title={checkJobFieldAvailable('plural')  ?`${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.PluralJobLabel}`  :strings.Jobs}
                        onSearch={(searchText) => this.setState({ searchText, offset: 0 }, () => this.getUserJobs())}
                        searchText={""}
                    />
                    {this.state.useDateFilter &&
                        <div style={{ paddingLeft: 30, paddingTop: 10, display: "flex" }}>
                            <ChooseListCalendarViewMode
                                viewMode={this.state.viewMode}
                                handleChange={viewMode => this.setState({ viewMode }, () => this.getUserJobs())}
                            />
                            {!CRMEnabled && dateFilter}
                        </div>
                    }
                    <br></br>
                    {CRMEnabled &&
                        <div style={{ display: "flex" }}>
                            <div style={{ display: "flex", marginTop: -17 }}>
                                <div style={{ display: "flex", marginLeft: "30px", }}>
                                    <SelectField
                                        data-intercom-target={"menu-Employees-Jobs-Filter-Select-Status"}
                                        floatingLabelText={strings.Status}
                                        value={this.state.status}
                                        onChange={(event, key, status) => this.setState({ status }, () => this.getUserJobs())}
                                        style={{ maxWidth: 130, marginRight: 8 }}
                                    >
                                        {this.state.jobStatuses
                                            .map((item, index) =>
                                                <MenuItem key={index} value={item} primaryText={item.Name} />
                                            )
                                        }
                                    </SelectField>
                                    <SelectField
                                        data-intercom-target={"menu-Employees-Jobs-Filter-Select-SubStatus"}
                                        floatingLabelText={strings.Substatus}
                                        value={this.state.subStatus}
                                        onChange={(event, key, subStatus) => this.setState({ subStatus }, () => this.getUserJobs())}
                                        disabled={this.state.status === null || this.state.status === undefined ? true : false}
                                        style={{ maxWidth: 130 }}
                                    >
                                        {this.state.status && this.state.status.SubStatuses
                                            .map((item, index) =>
                                                <MenuItem key={index} value={item} primaryText={item.Name} />
                                            )
                                        }
                                    </SelectField>
                                </div>
                                {(this.state.status !== null || this.state.subStatus !== null) && (
                                    <ClearIcon
                                        data-intercom-target={"menu-Employees-Jobs-Btn-ClearStatusFilter"}
                                        style={{ marginLeft: "1%", marginTop: "12%", cursor: "pointer", }}
                                        onClick={() => this.setState({ status: null, subStatus: null }, () => this.getUserJobs())}
                                    />
                                )}
                            </div>
                            <div style={{ marginLeft: 15, marginTop: -16 }}>
                                <Toggle
                                    data-intercom-target={"menu-Employees-Jobs-Filter-Toggle-Requested"}
                                    onToggle={(e, checked) =>
                                        this.setState({ requested: checked }, () => this.getUserJobs())
                                    }
                                    style={{ width: 150 }}
                                    defaultToggled={this.state.requested}
                                    label={strings.Requested}
                                />
                                <Toggle
                                    data-intercom-target={"menu-Employees-Jobs-Filter-Toggle-Available"}
                                    onToggle={(e, checked) =>
                                        this.setState({ available: checked }, () => this.getUserJobs())
                                    }
                                    style={{ width: 150 }}
                                    defaultToggled={this.state.available}
                                    label={strings.Available}
                                />
                                <Toggle
                                    data-intercom-target={"menu-Employees-Jobs-Filter-Toggle-ConfirmedWork"}
                                    onToggle={(e, checked) =>
                                        this.setState({ confirmed: checked }, () => this.getUserJobs())
                                    }
                                    style={{ width: 150 }}
                                    defaultToggled={this.state.confirmed}
                                    label={strings.Confirmed_Work}
                                />
                            </div>
                            <div style={{ marginLeft: 15, marginTop: -16, display: "flex" }}>
                                <SelectField
                                    data-intercom-target={"menu-Employees-Jobs-Filter-Select-DistanceToJob"}
                                    floatingLabelText={checkJobFieldAvailable('singular') ? `Distance To ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel}` : strings.Distance_To_Job}
                                    value={this.state.miles || ""}
                                    onChange={(event, key, miles) => this.setState({ miles }, () => this.getUserJobs())}
                                    style={{ maxWidth: 150, marginRight: 8 }}
                                >
                                    {[10, 20, 30, 40, 50, 100]
                                        .map((item, index) =>
                                            <MenuItem key={index} value={item} primaryText={`${item} ${strings.Miles.toLowerCase()}`} />
                                        )
                                    }
                                </SelectField>
                                {(this.state.miles !== undefined) && (
                                    <ClearIcon
                                        data-intercom-target={"menu-Employees-Jobs-Btn-ClearDistanceToJob"}
                                        style={{ marginLeft: "1%", marginTop: "22%", cursor: "pointer", }}
                                        onClick={() => this.setState({ miles: undefined }, () => this.getUserJobs())}
                                    />
                                )}
                            </div>
                            {this.state.useDateFilter &&
                                dateFilter
                            }
                        </div>
                    }
                    {!this.state.useDateFilter || this.state.viewMode === EListCalendarViewModes.ListView ?
                        <div style={{ padding: 20 }}>
                            {this.state.loading ?
                                <div className="spinner">
                                    <CircularProgress />
                                </div> :
                                <div>
                                    {!this.state.userJobs.length ?
                                        <h2 style={{ textAlign: "center", marginTop: 25 }}>{checkJobFieldAvailable('singular') ? `No ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel.toLowerCase()} found `: strings.No_job_found}</h2> :
                                        <UserDetailsJobsTable
                                            readonly={false}
                                            jobs={this.state.userJobs}
                                            selectedJobs={this.state.selectedJobs}
                                            total={this.state.total}
                                            offset={this.state.offset}
                                            limit={this.state.limit}
                                            limitOptions={[20, 50, 100]}
                                            milesFilter={this.state.miles !== undefined}
                                            onPageClick={offset => this.setState({ offset }, () => this.getUserJobs())}
                                            onLimitChange={limit => this.setState({ offset: 0, limit }, () => this.getUserJobs())}
                                            handleClickRow={jobId => browserHistory.replace(`/job-details/${jobId}`)}
                                            handleSelectJobs={selectedJobs => this.setState({ selectedJobs })}
                                        />
                                    }
                                </div>
                            }
                        </div> :
                        <div style={{ padding: 20 }}>
                            {this.state.loading ?
                                <div className="spinner">
                                    <CircularProgress />
                                </div> :
                                <UserJobCalendarView
                                    jobs={this.state.userJobs}
                                    refereceDate={moment(this.state.referenceDateForCalendarView).toDate()}
                                    milesFilter={this.state.miles !== undefined}
                                />
                            }
                        </div>
                    }
                </div>
                {this.state.openJobRequestDialog &&
                    <AddUserDetailRequestedJobDialog
                        employee={this.props.user}
                        handleRequestJob={this.handleRequestJob}
                        closeDialog={() => this.setState({ openJobRequestDialog: false })}
                        getUserJobs={this.getUserJobs}
                    />
                }
            </div>
        )
    }
}
